import { atom } from "recoil";

export const crmActiveTab = atom({
  key: 'crmActiveTab',
  default: 'new'
})


export const homeLoading = atom({
  key: 'homeLoading',
  default: true
})
